<template>
  <div class="fixed-top" style="z-index:500;">
    <nav class="navbar navbar-light bg-light">
      <img v-if="magEnable===true" class="pointer" style="width:200px"  @click="$router.push({ name: aiOnly === false ? 'Home' : 'ai_assistantIntro'})" src="../assets/image/live_logo.png" alt="">
      <img v-if="magEnable===false" class="pointer" style="width:200px"  @click="$router.push({ name: aiOnly === false ? 'Home' : 'ai_assistantIntro'})" src="../assets/image/pic/logo_liveLearning.png" alt="">
      <div class="d-flex" v-if="aiOnly===false">
        <span v-if="magEnable===false">
          <span class="mx-sm-2 d-flex pointer" @click="goPage('search')" >
            <img class="rwd-hide" style="width:24px" src="../assets/image/icon&btn/icon_other/Home_icon_Search.png" alt="">
            <span>{{ $t('Navbar.overview') }}</span>
          </span>
        </span>
        <span v-if="magEnable===false">
          |
        </span>
        <span class="mx-sm-2 d-flex pointer" @click="goPage('personal')">
          <img class="rwd-hide" style="width:24px" src="../assets/image/icon&btn/icon_other/Home_icon_User.png" alt="">
          <span>{{ $t('Personal.PersonalArea') }}</span>
        </span>
        |
        <span class="mx-2">
          <span v-if="!authorized" class="pointer">{{ $t('Login.login') }}</span>
          <span v-else @click="logout" class="pointer">{{ $t('Login.log_out') }}</span>
        </span>
      </div>
      <div v-else>
        <span class="mx-2">
          <span v-if="!authorized" class="pointer">{{ $t('Login.login') }}</span>
          <span v-else @click="logout" class="pointer">{{ $t('Login.log_out') }}</span>
        </span>
      </div>
    </nav>
    <nav class="navbar navbar-expand-lg navbar-light bg-light main py-0">
      <!-- <a class="navbar-brand pointer" style="font-size:1rem;" @click="$router.push({ name: 'Home'})">首頁</a> -->
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav" v-if="authorized">
          <li v-if="channels.length>0" class="nav-item dropdown" v-for="(item, index) in channels" :key="item.id">
            <a class="nav-link" role="button" data-toggle="dropdown" @mouseenter="selectedMain=null,main =index"  v-if="aiOnly===false">
              <!-- {{item.name}}{{item.name_en}} -->
              {{locale!=="en"?item.name:item.name_en}}
            </a>
            <div :class="'main-menu'+index" class="dropdown-menu dropright main-menu m-0">
              <div class="main-menu-item" v-if="item.name === '多益專區'">
                <a class="dropdown-item topic-item pointer d-flex justify-content-between" @mouseenter="selectedMain=null" @click="goPage('raiders')">
                  <div class="menu-item">
                    {{ $t('Navbar.about_TOEIC') }}
                  </div>
                </a>
              </div>
              <div class="main-menu-item" v-if="item.name === '多益專區'">
                <a class="dropdown-item topic-item pointer d-flex justify-content-between" @mouseenter="selectedMain=null" @click="goPage('Toeic-Vocabularies')">
                  <div class="menu-item">
                    {{ $t('Navbar.must_know_vocabulary') }}
                  </div>
                </a>
              </div>
              <div class="main-menu-item" v-if="item.name === '學習資源'">
                <a class="dropdown-item topic-item pointer d-flex justify-content-between" @mouseenter="selectedMain=null" @click="goPage('newsletter')">
                  <div class="menu-item">
                    {{  $t('Navbar.newsletter')}}
                  </div>
                </a>
                <a class="dropdown-item topic-item pointer d-flex justify-content-between" @mouseenter="selectedMain=null"  @click="goPage('Ielts-Vocabularies')">
                  <div class="menu-item">
                    雅思單字
                  </div>
                </a>
              </div>
              <div class="main-menu-item" v-for="(el, index) in item.child"  @mouseover="mouseHover(el,index)" :key="index">
                <a @click="goPage(el.id)" v-if="el.items.length>0" class="dropdown-item pointer d-flex justify-content-between" :class="{'active': el.id === selectedMain}">
                  <div class="menu-item">
                    {{locale!=="en"?el.name:el.name_en}}
                  </div>
                  <div v-if="el.items.length>0" class="pl-5 arrow">
                    <font-awesome-icon class="pointer chevron" size="lg" :icon="['fa', 'chevron-right']" />
                  </div>
                </a>
                <div>
                  <div class="dropdown-menu sub-menu m-0" v-if="el.items.length>0" :style="{'height':adjustment}">
                    <div class="nav-item" v-for="(item, index) in el.items" :key="index">
                      <a class="dropdown-item pointer" @click.self="goSubPage(item)" >
                        <!-- {{item.name}}
                        {{item.name_en}} -->
                        {{locale!=="en"?item.name:item.name_en}}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="main-menu-item" v-if="item.name === '寫作專區'">
                <a class="dropdown-item topic-item pointer d-flex justify-content-between"  @click="goEmail" @mouseenter="selectedMain=null">
                  <div class="menu-item">
                    {{ $t('Navbar.email_sentence')}}
                  </div>
                </a>
              </div>
              <div class="main-menu-item" v-if="item.name === '寫作專區'">
                <a class="dropdown-item topic-item pointer d-flex justify-content-between" @click="goWriting" @mouseenter="selectedMain=null">
                  <div class="menu-item">
                    {{ $t('Navbar.essay_revision')}}
                  </div>
                </a>
              </div>
            </div>
          </li>
          <li v-if="magEnable===false && aiOnly === false" class="nav-item dropdown">
            <a class="nav-link" role="button" data-toggle="dropdown" @click="goBiz">
              {{ $t('Navbar.Biz_talk') }}
            </a>
          </li>
          <li v-if="aiEnable" class="nav-item dropdown">
            <router-link :to="{ name: 'AI_Home' }" class="nav-link" role="button" data-toggle="dropdown" @click.native="autoNavbar">
              {{ $t('Navbar.aiLittleHelper') }}
            </router-link>
          </li>
          <!-- <li class="nav-item dropdown">
            <router-link :to="{ name: 'TOEIC_list', params: { exam_type: 'toeic'} }" class="nav-link" role="button" data-toggle="dropdown" @click.native="autoNavbar">
              toeic
            </router-link>
          </li>
          <li class="nav-item dropdown">
            <router-link :to="{ name: 'TOEIC_list', params: { exam_type: 'toeicbridge'} }" class="nav-link" role="button" data-toggle="dropdown" @click.native="autoNavbar">
              toeic bridge
            </router-link>
          </li> -->
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import api from '../store/api'
export default {
  name: 'Navbar',
  data () {
    return {
      level: null,
      locale: window.localStorage.getItem('locale') || 'tw',
      channels: [],
      submenu: [],
      search: '',
      selectedMain: null,
      adjustment: '',
      main: ''
    }
  },
  computed: {
    ...mapGetters([
      'authorized',
      'userInfo',
      'authInfo'
    ]),
    aiEnable () {
      if (this.$store.state.auth.user.aiEnable === true) {
        return true
      } else {
        return false
      }
    },
    aiOnly () {
      if (this.$store.state.auth.user.aiOnly === true) {
        return true
      } else {
        return false
      }
    },
    magOnly () {
      if(this.authInfo.user.magOnly === true) {
        return true
      } else {
        return false
      }
    },
    magEnable () {
      if(this.authInfo.user.magEnable === true) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
  },
  mounted () {
    this.getChannel()
    this.getPersonalData()
  },
  methods: {
    ...mapMutations({
      dologout: 'logout'
    }),
    getPersonalData () {
      this.level = this.userInfo.level
    },
    goPage (id) {
      console.log(id)
      if (id === 'Toeic-Vocabularies') {
        this.autoNavbar()
        this.$router.push({ name: 'Toeic-Vocabularies'})
      } else if (id === 'Ielts-Vocabularies') {
        this.autoNavbar()
        this.$router.push({ name: 'Ielts-Vocabularies'})
      } else if (id === 'raiders') {
        this.autoNavbar()
        this.$router.push({ name: 'Raiders'})
      } else if (id === 'newsletter') {
        this.$router.push({ name: 'NewsLetter'})
      } else if (id === 'personal') {
        this.$router.push({ name: 'Target'})
        // this.$router.push({ name: 'Record'})
      } else if (id === 'search') {
        this.$router.push({ name: 'Search', query: { cefr: this.userInfo.level!=='NA'?this.userInfo.level: '' }})
      }  else if (id === 'faq') {
        this.$router.push({ name: 'FAQ'})
      } else {
        this.autoNavbar()
        this.$router.push({ name: 'Channels', params: { channel: id } })
        this.submenu = []
      }
    },
    autoNavbar () {
      if (document.body.clientWidth < 900) {
        const navBtn = document.querySelector('.navbar-toggler')
        navBtn.click()
      }
    },
    navbarHover () {
      document.addEventListener("DOMContentLoaded", function(){
      if (window.innerWidth > 992) {
          document.querySelectorAll('.navbar .nav-item').forEach(function(everyitem) {
            everyitem.addEventListener('mouseover', function(e){
              let el_link = this.querySelector('a[data-bs-toggle]')
              if(el_link != null){
                let nextEl = el_link.nextElementSibling
                el_link.classList.add('show')
                nextEl.classList.add('show')
              }
            })
            everyitem.addEventListener('mouseleave', function(e){
              let el_link = this.querySelector('a[data-bs-toggle]')
              if (el_link != null) {
                let nextEl = el_link.nextElementSibling
                el_link.classList.remove('show')
                nextEl.classList.remove('show')
              }
            })
          })
        }
      })
    },
    goSubPage (el) {
      console.log(el)
      if (el.type === 'internal_link') {
        this.$router.push({ name: 'Topic-Exam', params: { channel: el.id, id: el.url } })
      } else {
        this.$router.push({ name: 'Course', params: { channel: el.id } })
      }
    },
    goBiz () {
      this.autoNavbar()
      this.$router.push({ name: 'Biz-talk'})
    },
    goWriting () {
      this.autoNavbar()
      this.$router.push({ name: 'WritingList'})
    },
    goEmail () {
      this.autoNavbar()
      this.$router.push({ name: 'Email-Sentence'})
    },
    async getChannel () {
      const { data } = await api.get('/contents/channels')
      let newData = data.data
      newData = newData.filter((el)=> {
        return el.name !== '雅思專區'
      })
      this.channels = newData
    },
    async getSubChannel (id) {
      const { data } = await api.get(`/contents/channels/${id}`, { headers: {'showLoading': false }} )
      this.submenu = data.data.items
    },
    logout () {
      if (this.magOnly || this.magEnable) {
        this.$router.push({ name: 'Mag' })
      } else {
        this.$router.push({ name: 'Login' })
      }
      this.dologout()
    },
    doSearch () {
      this.$router.replace({ name: 'Search', query: {q: this.search} })
    },
    mouseHover (el,index) {
      this.selectedMain = el.id
      if (index+1 > el.items.length) {
        this.adjustment = document.querySelector(`.main-menu${this.main}`).offsetHeight + 'px'
      } else {
        this.adjustment = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/styles/color.scss";
@import "../assets/styles/custom.scss";
  .main {
    min-height: 45px;
    background-color: $main-color !important;
  }
  .navbar {
    a{
      font-size: 1.2rem;
      color: $white-color !important;
    }
    z-index: 0;
    }
  .dropdown-menu {
    background-color: $light-gray;
    // text-align: center;
    text-align: left;
    .main-title {
      line-height: 3rem;
      font-weight: bolder;
      border-bottom: black 1px solid;
    }
    a {
      color: #000 !important;
      .arrow {
        display: none;
      }
    }
    // .dropdown-item:hover,:active {
    //   background-color: $sub-color !important;
    //   color: #ffff !important;
    // }
    .active {
      color: #ffff !important;
      background-color: $sub-color !important;
    }
  }
  .search {
    width: 100%;
    position: relative;
    .fa-search {
      margin-left: 5px;
      background-color: #fff;
      cursor: pointer;
      color: rgb(117, 117, 117);
    }
  }

  .sub-menu {
    // min-height: 50vh;
    max-height: 80vh;
    overflow: auto;
    background-color: $light-gray!important;
    .dropdown-item:hover,:active {
      background-color: $gray-color !important;
      color: #ffff !important;
    }
  }
  .topic-item:hover {
    color: #ffff !important;
    background-color: $sub-color !important;
  }
  @media all and (min-width: 992px) {
    .navbar .nav-item .dropdown-menu{ display: none; }
    .navbar .nav-item:hover .main-menu{ display: block; }
    .navbar .main-menu .main-menu-item:hover .sub-menu{ display: block; }
    .arrow {
      display: block !important;
    }
  }
  @media all and (max-width: 992px) {
    .menu-item {
      margin: auto;
    }
  }
</style>
